import axios from 'axios';

import { RECORDING_EXPORT } from '../config/apiPaths';
import { getUserUuidHeaders } from '../utils/httpUtils';
import { processApiPath } from '../utils/url';

export type ResponseRecordingsExport = {
    url?: string;
    inProgress?: boolean;
};

export const getRecordingsExportUrl = async (userUuid: string): Promise<ResponseRecordingsExport | null> => {
    const headers = { 'Content-Type': 'application/json', ...getUserUuidHeaders(userUuid) };

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const locale = navigator.language || 'en-US';

    try {
        const { data } = await axios.get<ResponseRecordingsExport>(processApiPath(RECORDING_EXPORT), {
            headers,
            params: { timeZone, locale }
        });

        return data;
    } catch (e) {
        console.error(e);
    }
    return null;
};
